import React from "react";
import { JOIN_ROOM, USER_SEND_MESSAGE_EVENT, USER_EVENTS_LISTING_LISTENER, USER_EVENTS_LISTING_EVENT, USER_GET_CHAT_EVENT, USER_GET_CHAT_LIST_LISTENER, USER_GET_MESSAGE_LISTENER, USER_JOINED_ROOM_LISTENER } from "./eventconst.ts";
import { io } from "socket.io-client";

export const ChatContext = React.createContext({})

const ChatProvider = (props) => {

    const params = new URLSearchParams(window.location.search);
    const userId = params.get("user_id") || '';
    const eventid = params.get("event_id") || '';

    const userToken = sessionStorage.getItem('userToken')

    const connectionUrl = process.env.REACT_APP_SOCKET_URL

    const [messages, setMessages] = React.useState([])
    const [events, setEvents] = React.useState({ data: [], total_count: 0 });
    const [connectionId, setConnectionId] = React.useState(userId || '');
    const [eventId, setEventId] = React.useState(eventid || '');
    const socketRef = React.useRef();
    const [messageLoad, setMessageLoad] = React.useState(false)
    const [socketConnect, setSocketConnect] = React.useState(false)
    const socketConnectRef = React.useRef(0)
    const messagePageRef = React.useRef(0)
    const messageBottomRef = React.useRef()
    const ChatScrollRef = React.useRef()
    const connectionIdRef = React.useRef('')
    const listenersInitialized = React.useRef(false);
    const eventsRef = React.useRef([]);
    const [unreadCount, setUnreadCount] = React.useState(0);

    console.log(unreadCount, 'unreadCount');

    const getEventsList = (eventData) => {
        setEvents((events) => {
            return {
                ...events,
                data: eventData.event,
            }
        });
        eventsRef.current = eventData.event
        const totalUnread = eventData.event.reduce((sum, event) => sum + (event.isUnRead || 0), 0);
        setUnreadCount(totalUnread);
    }

    const getMessage = (messageRes) => {
        const params = new URLSearchParams(window.location.search);
        const eventid = params.get("event_id") || '';
        const currentUserId = sessionStorage.getItem('userId')
        const userId = messageRes?.receiver?._id
        // if (eventid !== messageRes?.event?._id) {
        if (currentUserId === userId) {
            setUnreadCount(prev => prev + 1);
            // return;
        }
        let filteredData = eventsRef.current
        let index = filteredData.findIndex((res) => res?._id === eventid)
        if (index !== -1) {
            filteredData[index].isUnRead = 0
            setEvents((events) => {
                return {
                    ...events,
                    data: filteredData,
                }
            });
        }
        // setMessages((prevMessages) => [...prevMessages, messageRes]);

        setMessages((prevMessages) => {
            const exists = prevMessages.some(
                (msg) =>
                    msg._id === messageRes._id ||
                    (msg._id && msg._id === messageRes._id)
            );

            if (exists) {
                return prevMessages.map((msg) =>
                    msg._id === messageRes._id ? messageRes : msg
                );
            }
            return [...prevMessages, messageRes];
        });

        setTimeout(() => {
            messageBottomRef.current?.scrollIntoView({
                behavior: "smooth"
            });
        }, 200);
    };

    const getMessageList = (messages) => {
        const params = new URLSearchParams(window.location.search);
        const eventid = params.get("event_id") || '';
        setMessages(messages)
        let filteredData = eventsRef.current
        let index = filteredData.findIndex((res) => res?._id === eventid)
        if (index !== -1) {
            filteredData[index].isUnRead = 0
            setEvents((events) => {
                return {
                    ...events,
                    data: filteredData,
                }
            });
        }
        setTimeout(() => {
            messageBottomRef.current?.scrollIntoView({
                behavior: "smooth"
            });
        }, 200);
    }

    const sendMessage = (messageBody) => {
        if (!socketRef.current?.connected) return 'Please connect chat';
        socketRef.current?.emit(USER_SEND_MESSAGE_EVENT, messageBody);
        return 'Message sent'
    };

    const roomListened = (data) => {
    }

    const createConnection = (receiver, event) => {
        setConnectionId('')
        setEventId('')
        setMessages([]);

        let filteredData = [...eventsRef.current];
        let index = filteredData.findIndex((res) => res?._id === event);
        if (index !== -1) {
            filteredData[index].isUnRead = 0;
            setUnreadCount(0);
        }

        messagePageRef.current = 0
        let data = { receiver, event }
        socketRef.current?.emit(JOIN_ROOM, data);
        socketRef.current?.emit(USER_GET_CHAT_EVENT, data);
    };

    React.useEffect(() => {
        if (!userToken) {
            setSocketConnect(false);
            return;
        }

        socketRef.current = io(connectionUrl, {
            extraHeaders: {
                auth: userToken,
            },
        });

        let eventsEmitTimeout;

        socketRef.current.on('connect', () => {
            setSocketConnect(true);
            clearTimeout(eventsEmitTimeout);
            eventsEmitTimeout = setTimeout(() => {
                let data = { search: '' };
                socketRef.current?.emit(USER_EVENTS_LISTING_EVENT, data);
            }, 100);
        });

        socketRef.current.on('disconnect', () => {
            setSocketConnect(false);
        });

        return () => {
            if (socketRef.current) {
                socketRef.current.off('connect');
                socketRef.current.off('disconnect');
                socketRef.current.disconnect();
            }
        };
    }, [userToken]);

    React.useEffect(() => {
        if (socketRef.current?.connected && !listenersInitialized.current) {
            listenersInitialized.current = true;

            socketRef.current.on(USER_EVENTS_LISTING_LISTENER, getEventsList);
            socketRef.current.on(USER_GET_CHAT_LIST_LISTENER, getMessageList);
            socketRef.current.on(USER_GET_MESSAGE_LISTENER, getMessage);
            socketRef.current.on(USER_JOINED_ROOM_LISTENER, roomListened);
        }

        return () => {
            if (socketRef.current?.connected) {
                socketRef.current.removeAllListeners(USER_EVENTS_LISTING_LISTENER);
                socketRef.current.removeAllListeners(USER_GET_CHAT_LIST_LISTENER);
                socketRef.current.removeAllListeners(USER_GET_MESSAGE_LISTENER);
                socketRef.current.removeAllListeners(USER_JOINED_ROOM_LISTENER);
            }
        };
    }, [socketConnect, userToken]);

    React.useEffect(() => {
        if (userId && eventId && socketConnect) {
            createConnection(userId, eventId);
        }
    }, [userId, connectionId, eventId, socketConnect]);

    return <ChatContext.Provider value={{ messages, socketRef, setEvents, messageBottomRef, messagePageRef, ChatScrollRef, events, setConnectionId, setEventId, connectionId, setMessages, createConnection, sendMessage, unreadCount }}>
        {props.children}
    </ChatContext.Provider>
}
export default ChatProvider;